module.exports = __webpack_public_path__ + "static/media/Sept28-17.94c427ad.png";